import React from "react";
import "./Hero3.css";

const Hero3 = (props) => {
  return (
    <section className="hero3" aria-label={props.heading || "Hero section"}>
      <div className="hero3-container">
        <header className="headings-h3">
          <h1>{props.heading}</h1>
          <h1 className="grey">{props.heading2}</h1>

          <p>{props.paragraph}</p>
        </header>
        <div className="hero3-image">
          <img
            src={props.imageSrc}
            alt={props.imageAlt || `${props.heading} illustration`}
            loading="lazy"
            width="600"
            height="400"
            title={props.heading}
          />
        </div>
      </div>
    </section>
  );
};

export default Hero3;
